import React from 'react';

const TabContext = React.createContext<{
  activeTabId?: null | string;
  setActiveTabId: (activeTab?: string) => void;
}>({
  activeTabId: null,
  setActiveTabId: () => null,
});

export const useTabContext = () => React.useContext(TabContext);

export interface ITabGroup {
  children: React.ReactNode;
  defaultActiveTab?: string;
  active?: string;
  setActive?: (activeTab?: string) => void;
}

export const TabGroup = ({
  children,
  defaultActiveTab,
  active,
  setActive,
}: ITabGroup) => {
  const [activeTabId, setActiveTabId] = React.useState(defaultActiveTab);
  return (
    <TabContext.Provider
      value={{
        activeTabId: active || activeTabId,
        setActiveTabId: setActive || setActiveTabId,
      }}
    >
      {children}
    </TabContext.Provider>
  );
};
